import React, { useState } from 'react'
import classNames from 'classnames'
import { RadioInputProps } from './RadioInput.d'

const RadioInputTile = ({
  label,
  name,
  onChange,
  options,
  required = false
}: RadioInputProps) => {
  const [value, setValue] = useState<string>('' as string)

  const handleInputChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    setValue(ev.target.value)
    if (typeof onChange === 'function') {
      onChange(ev)
    }
  }

  const wrapperClassNames = classNames({
    'min-w-[300px] flex-1 basis-3/4 w-auto brand2': true
  })

  const labelClassNames = classNames({
    'text-[14px] font-semibold text-default mb-1 flex items-center font-effra mb-4':
      true
  })

  const inputLabelClassNames = classNames({
    'relative h-[76px] w-[106px] md:h-[72px] md:w-[149px] flex px-[18px] items-center justify-center cursor-pointer':
      true,
    'appearance-none border border-dark rounded-lg hover:border-sky-50 hover:shadow-raised group/tile has-[:checked]:border-sky-50 has-[:checked]:shadow-raised':
      true
  })

  const inputClassNames = classNames({
    'invisible absolute peer/radioTile': true
  })

  const optionLabelClassNames = classNames({
    'block text-base font-normal text-secondary text-center leading-[20px] group-hover/tile:text-default group-hover/tile:font-semibold peer-checked/radioTile:text-default peer-checked/radioTile:font-semibold ':
      true
  })

  return (
    <div className={wrapperClassNames} data-testid='RadioInputTile'>
      <label className={labelClassNames} htmlFor={name}>
        {label}
      </label>
      <fieldset className='flex flex-wrap gap-3 md:gap-4' id={name}>
        {options
          ? options.map(
              ({ value: optionValue, label: optionLabel }, i: number) => {
                return (
                  <label
                    className={inputLabelClassNames}
                    htmlFor={`${name}-${i}`}
                    key={`${name}-${i}`}
                  >
                    <input
                      checked={value === optionValue}
                      className={inputClassNames}
                      id={`${name}-${i}`}
                      name={name}
                      onChange={(ev) => handleInputChange(ev)}
                      required={required}
                      type='radio'
                      value={optionValue}
                    />
                    <span className={optionLabelClassNames}>{optionLabel}</span>
                  </label>
                )
              }
            )
          : null}
      </fieldset>
    </div>
  )
}

export default RadioInputTile
